import React from 'react';
import { Plus, Trash2, MessageSquare, Lock } from 'lucide-react';

const ConversationList = ({ conversations, activeId, onSelect, onNew, onNewPrivate, onDelete }) => {
  const formatDate = (d) => {
    const date = new Date(d);
    const now = new Date();
    const diff = now - date;
    if (diff < 86400000) return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    if (diff < 604800000) return date.toLocaleDateString('fr-FR', { weekday: 'short' });
    return date.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' });
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.title}>Historique</span>
        <div style={{ display: 'flex', gap: 6 }}>
          {onNewPrivate && (
            <button
              onClick={onNewPrivate}
              style={styles.privateBtn}
              title="Nouveau chat privé : zéro profil extrait, zéro résumé, zéro trace permanente"
            >
              <Lock size={14} />
            </button>
          )}
          <button onClick={onNew} style={styles.newBtn} title="Nouvelle discussion">
            <Plus size={16} />
          </button>
        </div>
      </div>
      <div style={styles.list}>
        {conversations.length === 0 && (
          <div style={styles.empty}>Aucune conversation</div>
        )}
        {conversations.map(conv => (
          <div
            key={conv.id}
            onClick={() => onSelect(conv.id)}
            style={{ ...styles.item, ...(activeId === conv.id ? styles.itemActive : {}) }}
          >
            {conv.memory_scope === 'ephemeral'
              ? <Lock size={14} style={{ flexShrink: 0, color: '#f59e0b' }} />
              : <MessageSquare size={14} style={{ flexShrink: 0, color: activeId === conv.id ? 'var(--accent)' : 'var(--text-secondary)' }} />
            }
            <div style={styles.itemContent}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div style={styles.itemTitle}>{conv.title}</div>
                {conv.mode === 'comm' && (
                  <span style={{ fontSize: 9, fontWeight: 600, color: '#10b981', background: 'rgba(16,185,129,0.12)', padding: '1px 5px', borderRadius: 4, flexShrink: 0 }}>COMM</span>
                )}
                {conv.memory_scope === 'ephemeral' && (
                  <span
                    title="Hors mémoire"
                    style={{ fontSize: 9, fontWeight: 600, color: '#f59e0b', background: 'rgba(245,158,11,0.12)', padding: '1px 5px', borderRadius: 4, flexShrink: 0 }}
                  >
                    PRIVÉ
                  </span>
                )}
              </div>
              <div style={styles.itemDate}>{formatDate(conv.updated_at)}</div>
            </div>
            <button
              onClick={(e) => { e.stopPropagation(); onDelete(conv.id); }}
              style={styles.deleteBtn}
              title="Supprimer"
            >
              <Trash2 size={12} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: 260, minWidth: 260, borderRight: '1px solid var(--history-border)',
    display: 'flex', flexDirection: 'column', background: 'var(--history-bg)', height: '100%',
  },
  header: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '14px 16px', borderBottom: '1px solid var(--history-border)',
  },
  title: { fontSize: 14, fontWeight: 600, color: 'var(--text)' },
  newBtn: {
    width: 30, height: 30, borderRadius: 8, border: '1px solid var(--card-border)',
    background: 'var(--card-bg)', color: 'var(--text)', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  privateBtn: {
    width: 30, height: 30, borderRadius: 8, border: '1px solid rgba(245,158,11,0.35)',
    background: 'rgba(245,158,11,0.08)', color: '#f59e0b', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    transition: 'all 0.15s',
  },
  list: { flex: 1, overflowY: 'auto', padding: '8px' },
  empty: { color: 'var(--text-secondary)', fontSize: 13, textAlign: 'center', padding: '24px 0' },
  item: {
    display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px',
    borderRadius: 8, cursor: 'pointer', marginBottom: 4, transition: 'background 0.15s',
  },
  itemActive: { background: 'var(--accent-light)' },
  itemContent: { flex: 1, minWidth: 0 },
  itemTitle: {
    fontSize: 13, fontWeight: 500, color: 'var(--text)',
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
  },
  itemDate: { fontSize: 11, color: 'var(--text-secondary)', marginTop: 2 },
  deleteBtn: {
    background: 'none', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer',
    padding: 4, borderRadius: 4, opacity: 0.6, transition: 'all 0.15s',
  },
};

export default ConversationList;
